import {AutomationResourceTypes} from '@/api/automations'

export const SETTINGS_COMPANY_PROFILE = 'company-profile'
export const SETTINGS_USER_PROFILE = 'user-profile'
export const SETTINGS_USERS = 'users'
export const SETTINGS_LANGUAGE_PLACEHOLDERS = 'language-placeholders'
export const SETTINGS_BILLING = 'billing'
export const SETTINGS_RELATED_TEAMS = 'related-teams'
export const SETTINGS_LOCATIONS = 'locations'
export const SETTINGS_SUBSIDIARIES = 'subsidiaries'
export const SETTINGS_DEPARTMENTS = 'departments'
export const SETTINGS_COST_CENTRES = 'cost-centres'
export const SETTINGS_DOCUMENTS = 'documents'
export const SETTINGS_LIMITS = 'limits'
export const SETTINGS_DASHBOARDS = 'dashboards'
export const SETTINGS_SAVED_QUESTIONS = 'saved-questions'
export const SETTINGS_INBOXES = 'inboxes'
export const SETTINGS_INBOX_TEMPLATES = 'inbox-templates'
export const SETTINGS_SAVED_REPLIES = 'saved-reply'
export const SETTINGS_BLOCKED = 'blocked'
export const SETTINGS_CONTACTS = 'suppliers'
export const SETTINGS_ADDRESSES = 'addresses'
export const SETTINGS_API_KEYS = 'api_keys'
export const SETTINGS_MIDDLEWARE_SERVICE = 'middleware-services'
export const SETTINGS_WEBHOOKS = 'webhooks'
export const SETTINGS_APPS = 'apps'
export const SETTINGS_ACCOUNT_DATA = 'account-data'
export const SETTINGS_DATASETS = 'datasets'
export const SETTINGS_PRODUCTS = 'items'
export const SETTINGS_PRODUCTS_ALTERNATIVES = 'item-alt'
export const SETTINGS_UOM = 'uom'
export const SETTINGS_EXPORTS = 'exports'
export const SETTINGS_IMPORTS = 'imports'
export const SETTINGS_SCHEMA_EDITOR = 'schema-editor'
export const SETTINGS_NOTIFICATIONS = 'notifications'
export const SETTINGS_WORKFLOWS = 'workflows'
export const SETTINGS_WORKFLOW_GLOBAL_PROPERTIES = 'workflow_global_properties'
export const SETTINGS_AUTOMATION_CATEGORIES = AutomationResourceTypes.CATEGORY
export const SETTINGS_AUTOMATION_TRIGGERS = AutomationResourceTypes.TRIGGER_TEMPLATE
export const SETTINGS_AUTOMATION_CONDITIONS = AutomationResourceTypes.CONDITION_TEMPLATE
export const SETTINGS_AUTOMATION_ACTIONS = AutomationResourceTypes.ACTION_TEMPLATE
export const SETTINGS_AUTOMATION_TEMPLATES = 'automation_templates'
export const SETTINGS_AUTOMATION_LOGS = 'automation_logs'
export const SETTINGS_INTEGRATIONS = 'integrations'
export const SETTINGS_SALE_SOURCE = 'sale-source'
export const SETTINGS_EXTERNAL_SOURCES = 'external-sources'
export const SETTINGS_INBOX_CONNECTIONS = 'connections'
